import Header from './components/Header';
import LookupPage from './pages/LookupPage';
import './App.css';

function App() {
  return (
    <div className="app-shell">
      <Header />

      <main className="app-main">
        <LookupPage />
      </main>

      <footer className="app-footer">
        <p>© {new Date().getFullYear()} Trường Đại học Công nghệ Giao thông Vận tải</p>
        <p>Mọi thắc mắc vui lòng liên hệ Ban tuyển sinh để được hỗ trợ. Hotline: 0243 552 6713</p>
      </footer>
    </div>
  );
}

export default App;
